module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoSB.8683b84.ttf";